
import React, { Component } from 'react'
import Scroll from 'react-scroll'
import getDayKey from '../../functions/getDayKey'
import hasToggleMovieDatesOnMobile from '../../hoc/hasToggleMovieDatesOnMobile'
import Showtimes from '../../SliderShowtimes/Showtimes'
import { trackMovieInformationOpen, trackMoviePerformanceOpen } from '../../tracking'
import FilterNoMovie from '../FilterNoMovie'
import FilterMovieInformation from './FilterMovieInformation'
import moment from 'moment'

let Element = Scroll.Element


class FilterResultsShowtimes extends Component {
    constructor(props) {
        super(props)
        
        this.onClickShowtimesPerformance = this.onClickShowtimesPerformance.bind(this)
    }

    componentDidUpdate(prevProps) {
        const { activeSelection, activePerformance, selectionId, onClosePerformancePage } = this.props

        if (activeSelection !== prevProps.activeSelection) {
            if(activeSelection && activePerformance && activeSelection !== selectionId) {
                onClosePerformancePage()
            }
        }
    }

    onClickShowtimesPerformance(perfObj) {
        const { translation, onOpenPerformancePage, toggleMovieDatesOnMobileView } = this.props
        const { timeUtc } = perfObj
        const dayKey = getDayKey(timeUtc, translation.timezone)

        toggleMovieDatesOnMobileView(dayKey)
        onOpenPerformancePage(perfObj)
    }

    render()  {
        const {
            items, 
            itemsData, 
            translation,
            activeFilters,
            dayFilters,
            theme,
            activeItem,
            isMobile,
            displaySidebarRightSecond,
            toggleMovieDatesOnMobileView,
            programOverviewShowtimesType,
            queryStringValues,
            currentDateActive,
            activePerformance,
            performancePageOpen,
            hiddenAttributes,
            onOpenPerformancePage,
            onClosePerformancePage,
            attributeStyling,
            hideCinemaSelector,
            additionalScrollName='',
            clusterCinemaActive,
            clusterCinemaOption,
            informationStyling,
            activeCinema 
        } = this.props

        if(0 === items.length) {
            return <FilterNoMovie translation={translation} />
        }
        
        const scrollToPosition = 'showtimes-position'
        
        let filterPerformancesArray = []
        let startDate = false
        let endDate = false

        if(queryStringValues.time) {
            const hasEndDate = Array.isArray(queryStringValues.time) ? _.find(queryStringValues.time, val => {
                return val.search("end") !== -1
            }):  _.find([queryStringValues.time], val => {
                return val.search("end") !== -1
            })
            const hasStartDate = Array.isArray(queryStringValues.time) ? _.find(queryStringValues.time, val => {
                return val.search("start") !== -1
            }) :  _.find([queryStringValues.time], val => {
                return val.search("start") !== -1
            })
            startDate = hasStartDate ? moment(parseInt(hasStartDate.split(':')[1])) : false
            endDate = hasEndDate ? moment(parseInt(hasEndDate.split(':')[1])) : false
        }

        if(activeFilters.hasOwnProperty('time')) {
            if(_.contains(activeFilters.time,'today') || _.contains(activeFilters.time,'tomorrow') || _.contains(activeFilters.time,'week')) {
                filterPerformancesArray = dayFilters[activeFilters.time] && dayFilters[activeFilters.time].performances ? dayFilters[activeFilters.time].performances : false 
            } else {
                const weekDayFilters = dayFilters ? Array.isArray(queryStringValues.time) ? _.intersection(_.keys(dayFilters.filterWeekDays), queryStringValues.time) : _.intersection(_.keys(dayFilters.filterWeekDays), [queryStringValues.time]) : []
                if(weekDayFilters) {
                    weekDayFilters.map(day => {
                        filterPerformancesArray = _.union(filterPerformancesArray, dayFilters['filterWeekDays'][day].performances)
            
                    })
                }
            }
        }

        let filterPerformances = filterPerformancesArray.length !== 0 ? filterPerformancesArray : false

        const eventOrigins = {
            showtime:               'Programmübersicht, Showtimes, Showtime Element',
            information:            'Programmübersicht, Showtimes, Film Information',
            informationSlidebar:    'Programmübersicht, Showtimes, Film Information/rechte Slidebar',
            details:                'Programmübersicht, Showtimes, Film Details',
            detailsSlidebar:        'Programmübersicht, Showtimes, Film Details/rechte Slidebar',
            performance:            'Programmübersicht, Showtimes, Film Vorführung'
        }
    
        return (
            <div className="overview-grid">
                <div className="list-showtimes">
                        <Element name={activeItem ? activeItem : 'none'} />
                        <Showtimes 
                            items={items}
                            moviesData={itemsData}
                            translation={translation}
                            startDate={startDate} 
                            endDate={endDate}
                            attributeStyling={attributeStyling}
                            clusterCinemaActive={clusterCinemaActive}
                            hiddenAttributes={hiddenAttributes}
                            clusterCinemaOption={clusterCinemaOption}
                            activeCinema={activeCinema}
                            dayFilters={dayFilters}
                            hasTitle={false}
                            activeFilters={activeFilters}
                            scrollToPosition={scrollToPosition + additionalScrollName}
                            programOverviewShowtimesType={programOverviewShowtimesType}
                            additionalScrollName={additionalScrollName}
                            filterPerformances={filterPerformances}
                            onClickItem={trackMoviePerformanceOpen(this.onClickShowtimesPerformance, eventOrigins.showtime)}
                        />
    
                        <Element name={scrollToPosition + additionalScrollName + ' movieInformation'}></Element>
                        <FilterMovieInformation
                            activeItem={activeItem}
                            informationStyling={informationStyling}
                            isMobile={isMobile}
                            itemsData={itemsData}
                            queryStringValues={queryStringValues}
                            clusterCinemaActive={clusterCinemaActive}
                            clusterCinemaOption={clusterCinemaOption}
                            activeCinema={activeCinema}
                            hideCinemaSelector={hideCinemaSelector}
                            theme={theme}
                            displaySidebarRightSecond={displaySidebarRightSecond} 
                            additionalScrollName={additionalScrollName}
                            toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView}
                            currentDateActive = {currentDateActive}
                            activePerformance={activePerformance}
                            performancePageOpen={performancePageOpen}
                            onOpenPerformancePage={onOpenPerformancePage}
                            onClosePerformancePage={onClosePerformancePage}
                            eventOrigins={eventOrigins}
                            translation={translation}
                        />
                </div>
            </div>
        )
    }
}

export default hasToggleMovieDatesOnMobile(FilterResultsShowtimes)